import { useState } from "react";

import "./WordList.css";

const WordList = ({ placeholder, list, addToList, removeFromList }) => {
  const [value, setValue] = useState("");
  return (
    <div className="word-list">
      <div className="word-list-controls">
        <input
          className="word-list-controls-input"
          placeholder={placeholder}
          value={value}
          onChange={(event) => setValue(event.target.value)}
        />
        <button
          type="button"
          className="word-list-controls-button"
          onClick={() => {
            if (!value.trim()) return;

            addToList(value.trim());
            setValue("");
          }}
        >
          Add
				</button>
      </div>
      <ul className="word-list-items">
        {(Array.isArray(list) ? list : []).map((text) => (
          <li className="word-list-items-item" key={text}>
            <span className="word-list-items-item-text">{text}</span>
            <button
              className="word-list-items-item-button"
              onClick={() => removeFromList(text)}
              type="button"
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WordList;
